import { render, staticRenderFns } from "./PromoPanel.vue?vue&type=template&id=f035edce&scoped=true"
import script from "./PromoPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./PromoPanel.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PromoPanel.vue?vue&type=style&index=0&id=f035edce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f035edce",
  null
  
)

export default component.exports